import { EMBEDDABLE_FILE_TYPES, FILE_TYPES_WHITELIST, ICON_BY_FILE_TYPE_DEFAULT_ICON, IMAGE_FILE_TYPES } from '@app/constants';

const extensionSetCheck = (filepath = '', dataSet: string[] = []): boolean => {
	const pieces = filepath.split('.');
	const ext = filepath.split('.').pop();

	if (!ext || pieces.length === 1) {
		return false;
	}

	return dataSet.indexOf(ext) > -1;
};

export const isApprovedFileType = (filepath: string): boolean => extensionSetCheck(filepath, FILE_TYPES_WHITELIST);
export const isImageFileType = (filepath: string): boolean => extensionSetCheck(filepath, IMAGE_FILE_TYPES);
export const isEmbeddableFileType = (filepath: string): boolean => extensionSetCheck(filepath, EMBEDDABLE_FILE_TYPES);

/**
 * Use the filepath to determine which icon to return.
 * For example images return an image icon. Returns a string
 * which is mapped to a Material icon icon ligature.
 */
export const getIconByFilePath = (filepath = ''): string => {
	const ext = filepath.split('.').pop();

	if (isImageFileType(filepath)) {
		return 'image';
	}

	switch (ext) {
		// PDF
		case 'pdf':
			return 'picture_as_pdf';
		// Spreadsheet
		case 'csv':
		case '.xlm':
		case '.xls':
		case '.xlt':
		case '.xlsx':
			return 'format_list_bulleted';
		// Zip File
		case '.z':
		case '.zip':
			return 'folder_open';
		// Plain Text
		case '.txt':
			return 'description';
	}

	return ICON_BY_FILE_TYPE_DEFAULT_ICON;
};
